export const KEY_NAMES = {
  NAME: 'name',
  ID: 'id',
  IDP_NAME: 'idpName',
  PREFERRED_MFA_EMAIL: 'email',
  PREFERRED_MFA_PHONE: 'phone'
};

export const LABELS = {
  ROLES: "Roles",
  ADD_USER: "Add User",
  USER_NAME: "User Name",
  IDENTITY_PROVIDER: "Identity Provider",
  DISPLAY_NAME: "Display Name",
  NAME: "Name",
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  EMAIL: "Email",
  GENERAL: "General",
  SIGN_IN_DETAILS: "Sign In Details",
  MOBILE_PHONE: "Mobile Phone",
  CONTACT_DETAILS: "Contact Details",
  SETTINGS: "Settings",
  USER_DETAIL: "User Detail",
  PREFERRED_MFA: "Preferred MFA",
  BLOCK_SIGN_IN: "Block Sign In",
  IS_MFA_ENABLED: "MFA Enabled?",
  TEMPORARY_PASSWORD: 'Temporary Password',
  ENABLE_MFA: 'Enable MFA',
  USE_EMAIL_AS_USERNAME: 'Use email as username',
  PASSWORD: 'Password',
  SHOW_PASSWORD: 'Show Password',
  HIDE_PASSWORD: 'Hide Password',
  ENABLE_PRE_REGISTRATION: 'Invite User',
  PRE_REGISTRATION_HINT: 'The user will receive an email to activate their account',
  DEFAULT_EMPTY_VALUE: "-",
  BUTTON_CANCEL: "Cancel",
  BUTTON_CLOSE: "Close",
  BUTTON_SAVE: "Save",
  BUTTON_SAVE_SETTINGS: 'Save Settings',
  EXTERNAL_IDP_ID: "externalIdpId",
  VALID_COLOR: "#27AE60",
  DEFAULT_COLOR: "#00000042",
};

export const MESSAGES = {
  USER_CREATE_SUCCESS: 'User {0} has been created',
  USER_CREATE_ERROR: 'There is some problem in creating user: ',
  USER_NAME_REQUIRED: 'User Name is required',
  LOCAL_USER_NAME_REQUIRED: 'User Name is required, Allowed characters include A-Z, a-z, 0-9, and (.!#$%&\'*+/=?^_`{|}~-)',
  IDP_REQUIRED: 'Identity Provider is required',
  USER_NAME_INVALID: 'Please enter a valid User Name',
  LOCAL_USER_NAME_INVALID: 'Please enter a valid User Name, Valid characters include A-Z, a-z, 0-9, and (.!#$%&\'*+/=?^_`{|}~-)',
  MOBILE_NUMBER_INVALID: 'Please enter a valid Mobile Number',
  MOBILE_NUMBER_REQUIRED: 'Mobile Number is required',
  EMAIL_REQUIRED: 'Email is required',
  EMAIL_INVALID: 'Please enter a valid Email',
  DISPLAY_NAME_REQUIRED: 'Diplay Name is required',
  PREFERRED_MFA_REQUIRED: 'Preferred MFA is required',
  ERROR_IN_FETCHING_IDENTITY_PROVIDER_NAME: 'There is some problem in fetching Identity Provider, please contact your system administrator.',
  FIRST_NAME_REQUIRED: 'First Name is required',
  LAST_NAME_REQUIRED: 'Last Name is required',
  PASSWORD_REQUIRED: 'Doesn\'t follow password policy',
  PASSWORD_POLICY: 'Password Policy',
  PASSOWORD_POLICY_ERROR: 'An unexpected error has occurred while fetching the password policy. Please refresh the page or contact the administrator if the problem persists.'
};

export const PREFERRED_MFA_LIST = [
  { key: KEY_NAMES.PREFERRED_MFA_EMAIL, displayName: 'Email' },
  { key: KEY_NAMES.PREFERRED_MFA_PHONE, displayName: 'Mobile Phone' }
];

export const BINARY_OPTIONS = {
  YES: 'Yes',
  NO: "No"
};

export const STATUS_CODES = {
  ERROR_404: 404,
  ERROR_400: 400,
  ERROR_500: 500
};

export const SNACKBAR_ALERT_DEFAULT_PROPS = {
  showSnackbar: true,
  autoHideDuration: 5000,
  message: '',
  severity: 'success' as 'success' | 'error'
};
export const PASSWORD_POLICY_ARRAY = {
  minMax: "Password length {0}-{1} characters",
  includeNumbers: "Numbers (e.g. 1, 2, 3, 4, etc.)",
  includeSpecialCharacters: "Special characters (e.g. !, @, #, $, etc.)",
  lettersInMixedCase: "Letters in mixed case (e.g. a, A, b, B, etc.)",
  maxConsecutiveLetters: "No more than {0} consecutive letters",
  commonPassword: "No common unsafe passwords (e.g. 123456, qwerty, etc.)"
};